import classNames from 'classnames';
import useStyles from './styles';
import { BannerContainerProps } from './types';

const BannerContainer = ({ children, backgroundImage, className }: BannerContainerProps) => {
  const classes = useStyles({ backgroundImage });
  return <div className={classNames(classes.root, className)}>{children}</div>;
};

export default BannerContainer;
